import React from "react";
import { StyleSheet, TouchableOpacity, Text, Platform } from "react-native";

import appStyles from "../../appStyles";
import AppTheme from "../AppTheme";
import ImageComponent from "../common/ImageComponent";

export default function RoutineItem({
  routine,
  onPress = () => {},
  onLongPress = () => {},
}) {
  return (
    <TouchableOpacity
      style={[styles.row, appStyles.borderBottom]}
      onPress={() => onPress(routine)}
      onLongPress={() => onLongPress(routine)}
    >
      <ImageComponent icon={routine.icon} style={styles.routineIcon} />
      <Text style={styles.routineName}>{routine.name}</Text>
      <Text style={styles.routineType}>
        {routine.time_interval}&nbsp;
        {routine.is_partial == 1 ? <Text>(Partial)</Text> : null}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: 40,
    paddingHorizontal: 16,
  },
  routineIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
  },
  routineName: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textTransform: "capitalize",
    flex: 1,
  },
  routineType: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    textAlign: "center",
    textTransform: "capitalize",
  },
});
